<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="primary" v-show="patients.length" dark class="mb-2" v-bind="attrs" v-on="on">
        <v-icon small class="mr-2">
          mdi-plus
        </v-icon>
        <span>
          Add to a group
        </span>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">
          <span v-if="!(!patients || !patients.length)">
            Add to a group
          </span>
        </span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-combobox
                v-model="model"
                :filter="filter"
                :hide-no-data="!search"
                :items="groups"
                :menu-props="menuProps"
                :search-input.sync="search"
                hide-selected
                label="Search or create a group"
                solo
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <span class="subheading">Press enter to create new group: </span>
                    <v-chip label small>
                      {{ search }}
                    </v-chip>
                  </v-list-item>
                </template>
                <template v-slot:selection="{ attrs, item, selected }">
                  <v-chip
                    v-if="item === Object(item)"
                    v-bind="attrs"
                    :input-value="selected"
                    label
                    small
                  >
                    <span class="pr-2">
                      {{ item.isNew && "New Group: " }}
                      {{ item.Name }}
                    </span>
                    <v-icon small @click="clear()">
                      $delete
                    </v-icon>
                  </v-chip>
                </template>
                <template v-slot:item="{ item }">
                  <v-chip dark label small>
                    {{ item.Name }}
                  </v-chip>
                </template>
              </v-combobox>
            </v-col>
          </v-row>
        </v-container>
        <small>* indicates required field</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="secondary" text @click="close">
          Cancel
        </v-btn>
        <v-btn color="primary" text @click="add">
          Add
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-snackbar v-model="snackbar">
      {{ notification }}

      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-dialog>
</template>

<script>
  /* eslint-disable */
import { ApiCalls } from "../../../../api-calls";
import UserHelper from "../../../../utils/user-helper";

export default {
  name: "AddPatientsToGroupDialog",
  components: {},
  props: {
    patients: {
      type: Array,
      default: null
    },
    groups: {
      type: Array,
      default: null
    },
    senders: {
      type: Array,
      default: null
    }
  },
  data: () => ({
    dialog: false,
    field: {
      name: "",
      message: "",
      mediaUrl: ""
    },
    selectedPatients: [],
    twilioSid: "ACfffb0bc0e31d44d40c9ecf9e6647c69d",
    practiceID: "",
    maxMessageLength: 200,
    snackbar: false,
    notification: "Unknown",
    file: null,
    activator: null,
    attach: null,
    colors: ["green", "purple", "indigo", "cyan", "teal", "orange"],
    editing: null,
    editingIndex: -1,
    items: [
      { header: "Select an option or create one" },
      {
        text: "Foo",
        color: "blue"
      },
      {
        text: "Bar",
        color: "red"
      }
    ],
    nonce: 1,
    menu: false,
    model: null,
    x: 0,
    search: null,
    y: 0
  }),

  watch: {
    dialog(val) {
      // eslint-disable-next-line no-unused-expressions
      val || this.close();
    },
    patients(val) {
      //if (val && val.length) {
      //  //val.forEach((item) => {
      //  //  this.selectedPatients.push(item);
      //  //  console.log("val :>> ", this.selectedPatients);
      //  //});
      //}
    },

    model(val, prev) {
      console.log("1111 val, prev :>> ", val, prev);
      if (typeof val === "string") {
        console.log("val :>> ", val);
        //  New
        this.items.push({
          Name: val,
          isNew: true
        });
        this.model = {
          Name: val,
          isNew: true
        };
      }
    }
  },

  computed: {
    menuProps() {
      return this.model ? { value: false } : {};
    }
  },
  created() {},

  methods: {
    clear() {
      console.log("this.model :>> ", this.model);
      this.model = null;
    },
    filter(item, queryText, itemText) {
      if (item.header) return false;

      const hasValue = val => (val != null ? val : "");

      const text = hasValue(itemText);
      const query = hasValue(queryText);

      return (
        text
          .toString()
          .toLowerCase()
          .indexOf(query.toString().toLowerCase()) > -1
      );
    },

    async add() {
      const activeClinic = UserHelper.getActiveClinic();
      const activePracticeId = activeClinic.PracticeID;
      let groupId = "";
      if (!this.model) {
        this.notification = "Please select a group to add";
        this.snackbar = true;
        return;
      }
      if (this.model.isNew) {
        try {
          this.$emit("show-loader");
          // Create a new group first
          const { data: newGroup } = await ApiCalls.createGroup({
            Name: this.model.Name,
            PracticeID: activePracticeId
          });
          groupId = newGroup.groupID;
        } catch (error) {
          this.notification = "Unable to create new group";
          this.snackbar = true;
          this.$emit("hide-loader");
          return;
        }
      } else {
        groupId = this.model.GroupID;
      }
      if (!groupId) {
        this.notification = "Invalid group selected";
        this.snackbar = true;
        this.$emit("hide-loader");
        return;
      }
      this.$emit("show-loader");
      // Add patients
      const formattedPatients = this.patients.map(p => ({
        FirstName: p.first_name,
        LastName: p.last_name,
        CellNumber: p.phone,
        GuarantorID: p.id
      }));
      try {
        await ApiCalls.addPatientsToGroup({
          GroupID: groupId,
          GuarantorList: formattedPatients
        }, groupId);
        this.$emit("hide-loader");
        this.$emit("on-success");
        this.dialog = false;
      } catch (error) {
        console.log('error :>> ', error);
        this.notification = "Unable to add patients";
        this.snackbar = true;
        this.$emit("hide-loader");
      }

      EventEmitter.dispatch("show-group-bulk-sms-composer", { patients: this.patients });

    },
    close() {
      this.dialog = false;
      this.file = null;
      this.items = [];
      this.model = null;
      this.field = Object.assign({
        name: "",
        message: "",
        mediaUrl: "",
        group: ""
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.placeHoldersWrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 15px 15px;
  margin-top: 25px;
  margin-bottom: 15px;
  background-color: rgb(58, 58, 58);
  border-radius: 8px;
}
.label {
  color: white;
  font-weight: 600;
}

.dropdown {
  display: inline-block;
  position: relative;
}

.dd-button {
  display: inline-block;
  border: 1px solid gray;
  border-radius: 4px;
  padding: 4px 80px 4px 60px;
  background-color: #ffffff;
  cursor: pointer;
  font-size: 1rem;
  white-space: nowrap;
}

.dd-button:after {
  content: "";
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid black;
}

.dd-button:hover {
  background-color: #eeeeee;
}

.dd-input {
  display: none;
}

.dd-menu {
  position: absolute;
  top: 100%;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 0;
  margin: 0 0 0 0;
  z-index: 5555555;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  list-style-type: none;
}

.dd-input + .dd-menu {
  display: none;
}

.dd-input:hover + .dd-menu {
  display: block;
}

.dd-menu li {
  width: 180px;
  padding: 0px 20px;
  cursor: pointer;
  white-space: nowrap;
}

.dd-menu li:hover {
  background-color: #f6f6f6;
}

.dd-menu li a {
  display: block;
  margin: -10px -20px;
  padding: 10px 20px;
}

.dd-menu li.divider {
  padding: 0;
  border-bottom: 1px solid #cccccc;
}
.toggleWrapper {
  display: flex;
  align-items: center;
  span {
    font-size: 1.1rem;
    margin-left: 1rem;
  }
  input[type="checkbox"] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    -webkit-tap-highlight-color: transparent;
    cursor: pointer;
  }
  input[type="checkbox"]:focus {
    outline: 0;
  }

  .toggle {
    height: 16px;
    width: 42px;
    border-radius: 16px;
    display: inline-block;
    position: relative;
    margin: 0;
    border: 2px solid grey;
    background: grey;
    transition: all 0.2s ease;
  }
  .toggle:after {
    content: "";
    position: absolute;
    top: 0px;
    left: 4px;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: white;
    box-shadow: 0 1px 2px rgba(44, 44, 44, 0.2);
    transition: all 0.2s cubic-bezier(0.5, 0.1, 0.75, 1.35);
  }
  .toggle:checked {
    border-color: rgb(0, 182, 91);
    background: rgb(0, 182, 91);
  }
  .toggle:checked:after {
    transform: translatex(20px);
  }
}
</style>
<style lang="scss">
.vdatetime-input {
  border-bottom: 2px solid black;
}
.fileWrapper {
  margin: 15px 0;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 7px 25px;
  border: 1px solid rgb(0, 182, 91);
  border-radius: 4px;
  box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.15);
  .filePart {
    flex: 7;
    display: flex;
    align-items: center;
    .iconWrapper {
      margin-right: 12px;
      color: rgb(0, 182, 91);
      * {
        color: rgb(0, 182, 91);
      }
    }
    .nameWrapper {
      margin-top: 3px;
      font-size: 0.9rem;
      font-weight: 400;
      line-height: 18px;
      .fileSize {
        font-size: 0.7rem;
        font-weight: 600;
      }
    }
  }
  .actionPart {
    flex: 3;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .changeBtn {
      background-color: rgb(56, 179, 255);
      padding: 0px 15px;
      cursor: pointer;
      font-weight: 600;
      color: white;
      * {
        font-size: 1.3rem;
        color: white;
        margin-top: -4px;
      }
      border-radius: 50px;
      font-size: 0.8rem;
    }
    .removeBtn {
      cursor: pointer;
      * {
        color: rgb(251, 59, 59);
      }
    }
  }
}
.uploadBtn {
  margin: 15px 0;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 7px 25px;
  justify-content: center;
  cursor: pointer;
  border: 1px solid rgb(0, 182, 91);
  border-radius: 4px;
  box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.15);
  .iconWrapper {
    margin-right: 12px;
    color: rgb(0, 182, 91);
    * {
      color: rgb(0, 182, 91);
    }
  }
  .labelWrapper {
    color: rgb(0, 182, 91);
    margin-top: 3px;
    font-size: 0.9rem;
    font-weight: 400;
  }
  &:hover {
    box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.088);
  }
}
.vue__time-picker.time-picker {
  border: none !important;
  border-bottom: 2px solid black !important;
  width: 12.5em !important;
  input {
    height: 1.6em !important;
    border: none !important;
    outline: none !important;
  }
}
</style>
